import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../services/auth-state.service';

export const authGuard: CanActivateFn = async () => {
  // 1. ALL injections must happen synchronously at the very top!
  const authState = inject(AuthStateService);
  const router = inject(Router);

  // 2. Perform async waits AFTER injections
  await authState.ensureAuthResolved();

  // 3. Evaluate routing logic
  const status = authState.status();

  if (status === 'authenticated') {
    return true;
  }

  if (status === 'needsVerification') {
    return router.createUrlTree(['/verify-email'], {
      queryParams: { email: authState.errorMessage() || '' }
    });
  }

  return router.createUrlTree(['/login']);
};

export const authChildGuard: CanActivateChildFn = async () => {
  // 1. Injections
  const authState = inject(AuthStateService);
  const router = inject(Router);

  // 2. Async Wait
  await authState.ensureAuthResolved();

  // 3. Logic
  const status = authState.status();

  if (status === 'authenticated') {
    return true;
  }

  if (status === 'needsVerification') {
    return router.createUrlTree(['/verify-email'], {
      queryParams: { email: authState.errorMessage() || '' }
    });
  }

  return router.createUrlTree(['/login']);
};

export const authPageGuard: CanActivateFn = async () => {
  // 1. Injections
  const authState = inject(AuthStateService);
  const router = inject(Router);

  // 2. Async Wait
  await authState.ensureAuthResolved();

  // 3. Logic
  if (authState.status() === 'authenticated') {
    return router.createUrlTree(['/social']);
  }

  if (authState.status() === 'needsVerification') {
    return router.createUrlTree(['/verify-email'], {
      queryParams: { email: authState.errorMessage() || '' }
    });
  }

  return true;
};